{
  "COMPANIES": {
    "HEADER": "Компании",
    "SORT_BY": {
      "LABEL": "Сортировать по",
      "OPTIONS": {
        "NAME": "Имя",
        "DOMAIN": "Домен",
        "CREATED_AT": "Дата создания",
        "LAST_ACTIVITY_AT": "Последние действия",
        "CONTACTS_COUNT": "Количество контактов"
      }
    },
    "ORDER": {
      "LABEL": "Сортировка",
      "OPTIONS": {
        "ASCENDING": "По возрастанию",
        "DESCENDING": "По убыванию"
      }
    },
    "SEARCH_PLACEHOLDER": "Поиск компаний...",
    "LOADING": "Загрузка компаний...",
    "UNNAMED": "Безымянная компания",
    "CONTACTS_COUNT": "{n} Контакт | {n} Контакта | Контактов",
    "ACTIONS": {
      "CREATE": "Добавить компанию"
    },
    "CREATE": {
      "TITLE": "Добавить информацию о компании",
      "ACTIONS": {
        "SAVE": "Добавить компанию"
      },
      "MESSAGES": {
        "SUCCESS": "Компания создана.",
        "ERROR": "Не удалось создать компанию."
      }
    },
    "DETAIL": {
      "LOADING": "Загрузка информации о компании...",
      "EMPTY_STATE": {
        "TITLE": "Компания не найдена",
        "SUBTITLE": "Возможно, эта компания была удалена или больше не доступна для этого аккаунта."
      },
      "SIDEBAR": {
        "TABS": {
          "ATTRIBUTES": "Свойства",
          "CONTACTS": "Контакты",
          "HISTORY": "История",
          "NOTES": "Заметки"
        }
      },
      "HISTORY": {
        "EMPTY": "Для контактов этой компании пока нет ни одной беседы."
      },
      "NOTES": {
        "EMPTY": "Заметки для контактов этой компании еще не найдены."
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Поиск по атрибутам...",
        "EMPTY_STATE": "Пользовательские атрибуты компании еще не настроены.",
        "NO_ATTRIBUTES": "Подходящие атрибуты не найдены.",
        "UNUSED_ATTRIBUTES": "{count} неиспользуемый атрибут | {count} неиспользованные атрибуты",
        "MESSAGES": {
          "UPDATE_SUCCESS": "Атрибут компании обновлён.",
          "UPDATE_ERROR": "Невозможно обновить атрибут компании.",
          "DELETE_SUCCESS": "Атрибут организации удален.",
          "DELETE_ERROR": "Не удалось удалить атрибут организации."
        }
      },
      "CONTACTS": {
        "LOADING": "Загрузка контактов...",
        "EMPTY": "Нет контактов связанных с этой компанией.",
        "UNNAMED_CONTACT": "Контакт без имени",
        "ACTIONS": {
          "ADD": "Добавить контакт",
          "REMOVE": "Удалить контакт"
        },
        "DIALOGS": {
          "ADD": {
            "DESCRIPTION": "Искать существующий контакт и привязать его к этой компании.",
            "SEARCH_PLACEHOLDER": "Поиск контактов...",
            "INITIAL": "Начните печатать для поиска контактов.",
            "EMPTY": "Контакты не найдены.",
            "CONFIRM_TITLE": "Связать контакт",
            "CONFIRM_DESCRIPTION": "Подтвердите компанию и свяжитесь с ней перед тем, как связать ее.",
            "COMPANY_LABEL": "Компания",
            "CONTACT_LABEL": "Контакт",
            "CURRENT_COMPANY": "В настоящее время связаны с {companyName}",
            "ADD": "Привязать контакт",
            "CANCEL": "Отменить"
          }
        },
        "MESSAGES": {
          "ADD_SUCCESS": "Контакт связан с компанией.",
          "ADD_ERROR": "Не удалось привязать контакт к компании.",
          "REASSIGN_SUCCESS": "Контакт переназначен компании.",
          "REASSIGN_ERROR": "Невозможно переназначить контакт с компанией.",
          "REMOVE_SUCCESS": "Контакт удалён из компании.",
          "REMOVE_ERROR": "Невозможно удалить контакт из компании."
        }
      },
      "AVATAR": {
        "UPDATING": "Обновление аватара компании ...",
        "UPLOAD_SUCCESS": "Аватар компании обновлён.",
        "UPLOAD_ERROR": "Невозможно обновить аватар компании.",
        "DELETE_SUCCESS": "Аватар компании удалён.",
        "DELETE_ERROR": "Невозможно удалить аватар компании."
      },
      "PROFILE": {
        "TITLE": "Изменение данных компании",
        "CREATED_AT": "Создано {date}",
        "LAST_ACTIVE": "Последняя активность {date}",
        "DESCRIPTION_PLACEHOLDER": "Добавить краткое описание этой компании",
        "ACTIONS": {
          "SAVE": "Обновить компанию"
        },
        "MESSAGES": {
          "UPDATE_SUCCESS": "Компания обновлена.",
          "UPDATE_ERROR": "Невозможно обновить компанию."
        },
        "FIELDS": {
          "NAME": "Имя",
          "DOMAIN": "Домен"
        }
      },
      "DELETE": {
        "SECTION_TITLE": "Опасная зона",
        "SECTION_DESCRIPTION": "Удалите эту компанию и отсоедините её контакты. Контакты останутся в учетной записи.",
        "BUTTON": "Удалить компанию",
        "TITLE": "Удалить компанию?",
        "DESCRIPTION": "Это удалит компанию и отсоединит все связанные с ней контакты. Контакты будут сохранены.",
        "DESCRIPTION_WITH_NAME": "Это удалит {companyName} и отсоединит все соответствующие контакты. Контакты будут сохранены.",
        "CONFIRM": "Удалить компанию",
        "MESSAGES": {
          "SUCCESS": "Компания удалена.",
          "ERROR": "Не удалось удалить компанию."
        }
      }
    },
    "EMPTY_STATE": {
      "TITLE": "Компаний не найдено"
    }
  },
  "COMPANIES_LAYOUT": {
    "PAGINATION_FOOTER": {
      "SHOWING": "Показано {startItem}–{endItem} из {totalItems} компании | Показано {startItem}–{endItem} из {totalItems} компаний"
    }
  }
}
